// extracted by mini-css-extract-plugin
export default {"trigger":"tooltip_trigger__N3+Nt","tooltip":"tooltip_tooltip__LYi39","fadeIn":"tooltip_fadeIn__8299I"};